import React from 'react';

export function GradientStarIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.8134 12.2473C22.2471 12.3931 22.7085 12.511 23.1846 12.5974C23.322 12.6223 23.4218 12.7418 23.422 12.8815C23.4221 13.021 23.3225 13.1408 23.1853 13.166C22.1009 13.3656 21.1162 13.7218 20.2589 14.225C17.5753 15.8016 16.5965 18.5019 16.2478 20.4894C16.2236 20.6274 16.1038 20.7283 15.9636 20.7284C15.9781 20.734 15.7217 20.7328 15.6786 20.4899C14.9939 16.6358 12.6668 13.8935 8.75884 13.1707C8.44503 13.1126 8.44496 12.6605 8.75866 12.6023C12.7031 11.8702 14.99 9.12273 15.6772 5.23758C15.7333 4.92079 16.1902 4.92082 16.2463 5.23758C16.8376 8.58108 18.6347 11.1783 21.8134 12.2473Z"
        fill="#1F2A37"
      />
      <path
        d="M4.50022 4.20342C4.86092 5.3569 5.60159 6.19812 6.7305 6.57253C6.84855 6.6117 6.92832 6.72195 6.92853 6.84643C6.92902 7.19624 6.57908 7.05853 5.87226 7.54288C5.80578 7.60859 4.93387 8.08633 4.50089 9.4866C4.46348 9.60743 4.35182 9.68998 4.22526 9.69019C4.2331 9.6929 4.01418 9.69588 3.94893 9.48751C3.59621 8.36061 2.85951 7.50892 1.71834 7.11823C1.45836 7.02921 1.4586 6.66035 1.71827 6.57141C2.86637 6.17815 3.59864 5.32027 3.94858 4.20325C3.98634 4.08277 4.09807 4.00064 4.22438 4.00064C4.21609 3.99779 4.43521 3.99551 4.50022 4.20342Z"
        fill="#1F2A37"
      />
      <path
        d="M8.50022 17.2034C8.86092 18.3569 9.60159 19.1981 10.7305 19.5725C10.8486 19.6117 10.9283 19.7219 10.9285 19.8464C10.929 20.1962 10.5791 20.0585 9.87226 20.5429C9.80578 20.6086 8.93387 21.0863 8.50089 22.4866C8.46348 22.6074 8.35182 22.69 8.22526 22.6902C8.2331 22.6929 8.01418 22.6959 7.94893 22.4875C7.59621 21.3606 6.85951 20.5089 5.71834 20.1182C5.45836 20.0292 5.4586 19.6604 5.71827 19.5714C6.86637 19.1781 7.59864 18.3203 7.94858 17.2032C7.98634 17.0828 8.09807 17.0006 8.22438 17.0006C8.21609 16.9978 8.43521 16.9955 8.50022 17.2034Z"
        fill="#1F2A37"
      />
      <path
        d="M3.75368 3.21447C4.08735 4.43062 4.77251 5.31754 5.81681 5.7123C5.92601 5.75359 5.9998 5.86983 6 6.00108C6.00046 6.36989 5.67674 6.22471 5.02289 6.73537C4.9614 6.80465 4.15483 7.30834 3.7543 8.78469C3.7197 8.91209 3.61641 8.99912 3.49933 8.99934C3.50658 9.0022 3.30407 9.00535 3.24371 8.78566C2.91743 7.59753 2.23594 6.69956 1.18029 6.28764C0.939799 6.19379 0.940026 5.80489 1.18023 5.71111C2.24228 5.29649 2.91967 4.392 3.24339 3.21429C3.27832 3.08726 3.38167 3.00068 3.49852 3.00068C3.49084 2.99767 3.69355 2.99526 3.75368 3.21447Z"
        fill="url(#paint0_linear_9785_80135)"
      />
      <path
        d="M7.74983 16.2145C8.08464 17.4356 8.77273 18.3192 9.81296 18.7124C9.92217 18.7535 9.99596 18.8699 9.99609 19.001C9.99658 19.3718 9.67465 19.2233 9.01892 19.7353C9.01892 19.7353 9.01892 19.7353 9.01889 19.7354C8.41912 20.2034 7.99235 20.8929 7.75042 21.7846C7.71581 21.9121 7.61253 21.9991 7.49545 21.9994C7.50257 22.0021 7.30019 22.0054 7.23983 21.7857C6.9127 20.5944 6.22945 19.6985 5.17637 19.2877C4.93588 19.1938 4.93614 18.8048 5.17634 18.7111C6.23628 18.2975 6.91514 17.3945 7.2395 16.2143C7.27443 16.0873 7.37775 16.0007 7.49464 16.0007C7.48693 15.9977 7.68967 15.9952 7.74983 16.2145Z"
        fill="url(#paint1_linear_9785_80135)"
      />
      <path
        d="M21.3805 11.3719C21.8171 11.5202 22.2817 11.64 22.761 11.7279C22.8993 11.7533 22.9998 11.8749 23 12.0169C23.0001 12.1589 22.8999 12.2807 22.7617 12.3063C21.6699 12.5094 20.6785 12.8717 19.8154 13.3835C17.1135 14.9872 16.128 17.7339 15.777 19.7555C15.7526 19.8959 15.6319 19.9985 15.4908 19.9986C15.5054 20.0044 15.2473 20.0032 15.2039 19.7561C14.5145 15.8357 12.1716 13.0464 8.237 12.3111C7.92106 12.252 7.92099 11.7921 8.23683 11.733C12.2081 10.9883 14.5106 8.19358 15.2025 4.24166C15.259 3.91943 15.719 3.91946 15.7755 4.24166C16.3708 7.64262 18.1801 10.2845 21.3805 11.3719Z"
        fill="url(#paint2_linear_9785_80135)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9785_80135"
          x1="1"
          y1="3"
          x2="6.90164"
          y2="7.91803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00F260" />
          <stop offset="1" stopColor="#0575E6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9785_80135"
          x1="4.99609"
          y1="16"
          x2="10.8977"
          y2="20.918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00F260" />
          <stop offset="1" stopColor="#0575E6" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9785_80135"
          x1="8"
          y1="4"
          x2="23.9667"
          y2="18.9688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00F260" />
          <stop offset="1" stopColor="#0575E6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
